import React from "react";
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AuroLogo from "../assets/images/Aura Logo black.png";
export default function Footer() {
  return (
    <div className="bg-[#fdf6f6] pt-10 relative">
      {/* Main content */}
      <div className="flex flex-col justify-center items-center">
        <div className="pb-32 w-full flex flex-col items-center">
          <div className="flex justify-center w-80 h-auto  ">
            <img
              src={AuroLogo}
              alt="Discover Modern 2 BHK Apartments in AURA"
              className="w-full h-full"
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L6.13843 7.19909C6.10711 7.20949 6.07526 7.21834 6.04298 7.2256C5.95342 7.24576 5.851 7.25 5.4175 7.25L3.8711 7.25C3.47574 7.24999 3.13466 7.24997 2.85373 7.27293C2.55722 7.29715 2.26231 7.35064 1.97852 7.49524C1.55516 7.71095 1.21095 8.05516 0.995237 8.47852C0.850642 8.76231 0.797155 9.05722 0.772929 9.35373C0.749977 9.63465 0.749988 9.97571 0.750001 10.3711V13.6289C0.749988 14.0243 0.749977 14.3653 0.772929 14.6463C0.797155 14.9428 0.850642 15.2377 0.995237 15.5215C1.21095 15.9448 1.55516 16.289 1.97852 16.5048C2.26231 16.6494 2.55722 16.7028 2.85373 16.7271C3.13466 16.75 3.47572 16.75 3.87108 16.75H5.4175C5.851 16.75 5.95342 16.7542 6.04298 16.7744C6.13913 16.796 6.23156 16.8318 6.31726 16.8804C6.39708 16.9258 6.47572 16.9915 6.79648 17.2831L11.186 21.2736C11.5232 21.5802 11.9625 21.75 12.4182 21.75C13.4299 21.75 14.25 20.9299 14.25 19.9182V15.3107L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L7.81903 6.75837C7.81677 6.75608 7.8145 6.75381 7.81221 6.75155L2.53033 1.46967ZM7.24396 8.30462C7.1836 8.34768 7.12208 8.38751 7.05797 8.42392C6.84373 8.54559 6.61267 8.63492 6.37229 8.68901C6.09926 8.75045 5.81917 8.75026 5.48085 8.75003L3.9 8.75C3.46759 8.75 3.18838 8.75058 2.97588 8.76795C2.77213 8.78459 2.69659 8.81285 2.65951 8.83175C2.51839 8.90365 2.40365 9.01839 2.33175 9.15951C2.31285 9.19659 2.28459 9.27213 2.26795 9.47588C2.25059 9.68838 2.25 9.96758 2.25 10.4V13.6C2.25 14.0324 2.25059 14.3116 2.26795 14.5241C2.28459 14.7279 2.31285 14.8034 2.33175 14.8405C2.40365 14.9816 2.51839 15.0963 2.65951 15.1683C2.69659 15.1872 2.77213 15.2154 2.97588 15.2321C3.18838 15.2494 3.46759 15.25 3.9 15.25L5.48085 15.25C5.81916 15.2497 6.09926 15.2496 6.37229 15.311C6.61266 15.3651 6.84373 15.4544 7.05798 15.5761C7.30133 15.7143 7.50846 15.9028 7.75863 16.1306L12.195 20.1637C12.2561 20.2192 12.3357 20.25 12.4182 20.25C12.6015 20.25 12.75 20.1015 12.75 19.9182V13.8107L7.24396 8.30462Z" fill="currentColor"/><path d="M12.4182 2.25C11.9625 2.25 11.5232 2.41985 11.186 2.72637L8.87645 4.826C8.56996 5.10463 8.54737 5.57896 8.826 5.88546C9.10463 6.19195 9.57896 6.21454 9.88546 5.93591L12.195 3.83628C12.2561 3.78076 12.3357 3.75 12.4182 3.75C12.6015 3.75 12.75 3.89854 12.75 4.08178L12.75 9.5C12.75 9.91422 13.0858 10.25 13.5 10.25C13.9142 10.25 14.25 9.91422 14.25 9.5L14.25 4.08178C14.25 3.07012 13.4299 2.25 12.4182 2.25Z" fill="currentColor"/><path d="M18.9505 3.40034C18.6193 3.15156 18.1491 3.21836 17.9003 3.54954C17.6516 3.88072 17.7184 4.35087 18.0495 4.59966C20.2979 6.28858 21.75 8.97446 21.75 12C21.75 13.7252 21.2784 15.338 20.4575 16.719C20.2459 17.0751 20.363 17.5353 20.719 17.7469C21.0751 17.9586 21.5353 17.8415 21.7469 17.4854C22.7018 15.879 23.25 14.0024 23.25 12C23.25 8.48258 21.5595 5.36028 18.9505 3.40034Z" fill="currentColor"/><path d="M17.0002 6.96898C16.6915 6.69274 16.2174 6.719 15.9412 7.02765C15.6649 7.33629 15.6912 7.81044 15.9998 8.08668C17.0751 9.04907 17.75 10.4452 17.75 12C17.75 12.6532 17.6311 13.2768 17.4144 13.8516C17.2683 14.2392 17.464 14.6719 17.8516 14.818C18.2392 14.9641 18.6719 14.7683 18.818 14.3807C19.0974 13.6394 19.25 12.8367 19.25 12C19.25 10.0008 18.3799 8.20388 17.0002 6.96898Z" fill="currentColor"/></svg>
          </div>
          {/* Contact Info & Footer Text */}
          <div className="xl:max-w-[50%] w-full mx-auto mt-10">
            <div className="xl:flex block justify-between items-start text-left">
              {/* Email */}
              <div className="flex-1 px-4">
                <h3 className="font-medium text-[20px] font-crimson mb-2 text-[#a64a10]">
                  Email:
                </h3>
                <p className="font-inter text-[17px]">
                  <a
                    href="mailto:info@tranquilloprojects.com"
                    className="text-[#000000d9] hover:text-[#a64a10] relative group transition-colors duration-300"
                  >
                    info@tranquilloprojects.com
                    <span className="absolute -bottom-2 left-1/2 w-0 h-[2px] bg-[#a64a10] transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
                  </a>
                </p>
              </div>

              {/* Phone */}
              <div className="flex-1 px-4">
                <h3 className="font-medium text-[20px] font-crimson mb-2 text-[#a64a10]">
                  Phone Number:
                </h3>
                <p className="font-inter text-[17px]">
                  <a
                    href="tel:+9190919 99916 "
                    className="text-[#000000d9] hover:text-[#a64a10]  relative group transition-colors duration-300"
                  >
                    +91 90919 99916
                    <span className="absolute -bottom-2 left-1/2 w-0 h-[2px] bg-[#a64a10] transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
                  </a>
                </p>
              </div>

              {/* Address */}
              <div className="flex-1 px-4">
                <h3 className="font-medium text-[20px] font-crimson mb-2 text-[#a64a10]">
                  Address:
                </h3>
                <p className="font-inter text-[15px]">
                  <a
                    href="https://maps.app.goo.gl/5fwH6As6zN34WXZa6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#000000d9] hover:text-[#a64a10] hover:underline"
                  >
                    S.no.119/P & 120/P Nandigaon (V), Patancheru - Shankarpalli
                    Rd, Hyderabad, Telangana 502300
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex items-center space-x-4 text-[#a64a10] mt-7">
            {/* <div className="border border-[#0000001a] h-5"></div> */}
            <Link
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
              to="https://www.instagram.com/tranquilloprojects/"
              target="_blank"
            >
              <InstagramIcon />
            </Link>
            <div className="border border-[#0000001a] h-5"></div>
            <Link
              to="https://wa.me/918906193333?text=Hi%2C%20I%27m%20interested%20in%20your%20project"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
            >
              <WhatsAppIcon />
            </Link>

            <div className="border border-[#0000001a] h-5"></div>
            <Link
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
              to="https://x.com/Tranquillobuild"
              target="_blank"
            >
              <XIcon />
            </Link>
            <div className="border border-[#0000001a] h-5"></div>
            <Link
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
              to="https://www.youtube.com/@tranquilloprojects2291/videos"
              target="_blank"
            >
              <YouTubeIcon />
            </Link>
            <div className="border border-[#0000001a] h-5"></div>
            <Link
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
              to="https://www.linkedin.com/company/tranquillo-projects"
              target="_blank"
            >
              <LinkedInIcon />
            </Link>
            <div className="border border-[#0000001a] h-5"></div>
            <Link
              className="bg-[#F6F4ED] rounded-lg shadow-custom opacity-100 p-[5px]"
              to="https://www.facebook.com/TranquilloProjects"
              target="_blank"
            >
              <FacebookOutlinedIcon />
            </Link>
          </div>
          {/* Footer Text */}
          <div className="flex gap-4 justify-center items-center mt-10 text-center">
            <p className="font-inter text-[15px]">&copy; 2026 Aura.</p>
            <div className="border border-[#0000001a] w-[100px] hidden xl:block"></div>
            <p className="font-inter text-[15px]">
              Powered By{" "}
              <a
                href="https://www.novatales.com/"
                className="font-inter text-[15px] hover:text-[#a64a10] relative group transition-colors duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                Novatales Media
                <span className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-[#a64a10] transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
